import { RoundBlackCard } from "../classes/RoundBlackCards";

export const shuffleRoundBlackCards = (roundBlackCards: RoundBlackCard[]) => {
    const tempRoundBlackCards = [...roundBlackCards];
    for (let idx = 0; idx < tempRoundBlackCards.length; idx++) {
      const swapIdx1 = Math.floor(Math.random() * tempRoundBlackCards.length);
      const swapIdx2 = Math.floor(Math.random() * tempRoundBlackCards.length);
      const c = tempRoundBlackCards[swapIdx1];
      tempRoundBlackCards[swapIdx1] = tempRoundBlackCards[swapIdx2];
      tempRoundBlackCards[swapIdx2] = c;
    }

    return [...tempRoundBlackCards];
}

export const getPlayedRoundBlackCardsCount = (roundBlackCards: RoundBlackCard[]) => {
    let count = 0;
    for (let idx = 0; idx < roundBlackCards.length; idx++) {
        if (roundBlackCards[idx].blackCardIdx > -1) {
            count++;
        }
    }
    return count;
}